import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import useStores from "@hooks/useStores";
import { BLOCKS } from "@contentful/rich-text-types";

const ContentTOCAlt = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	const options = {
		renderNode: {
			[BLOCKS.UL_LIST]: (node, children) => {
				return (
					<Box component="nav" mt={8}>
						<ul className={classes.tocUl}>{children}</ul>
					</Box>
				);
			},
			[BLOCKS.OL_LIST]: (node, children) => {
				return (
					<Box component="nav" mt={8}>
						<ul className={classes.tocUl}>{children}</ul>
					</Box>
				);
			},
			[BLOCKS.PARAGRAPH]: (_, children) => {
				return children;
			},
			[BLOCKS.LIST_ITEM]: (node, children) => {
				return (
					<li className={classes.tocItem}>
						<span className={classes.tocItemA}>{children}</span>
					</li>
				);
			},
		},
	};

	if (!store.hasAltTableOfContents) return "";

	return documentToReactComponents(
		store.content.rightColumn.tocAlt?.json,
		options
	);
};

ContentTOCAlt.propTypes = {};
export default ContentTOCAlt;
